var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.46875 7L2.23742 12.7862C1.91365 13.0869 1.40747 13.0681 1.10683 12.7444C0.806186 12.4206 0.824933 11.9144 1.1487 11.6138L6.11737 7L1.1487 2.38624C0.824933 2.0856 0.806186 1.57941 1.10683 1.25564C1.40747 0.931874 1.91365 0.913126 2.23742 1.21377L8.46875 7Z",
    fill: "#666666",
    stroke: "#666666",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.fdc33be8aec275eaab801465ba55fe77.svg";
export { ForwardRef as ReactComponent };